module.exports = __webpack_public_path__ + "static/media/MoreWaysToEarnAramark.4946d602.png";